import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

// Account creation constants for user info flow
export const MINIMUM_ACCOUNT_AGE = 16;

export const INITIAL_API_ERROR_POPUP_STATE = {
  displayPopup: false,
  errorMessage: ''
};

export const INITIAL_INVITE_USER_STATE = {
  ...BASIC_INITIAL_STATE
};